import React from 'react'
import { useFormContext } from 'react-hook-form'

import { bemJoin } from 'bem-join'

import { useIntl } from '@app/intl/Intl'
import { Text } from '@app/lib/typography/Text/Text'

export const VatTotal = () => {
  const b = bemJoin('court-case-invoicing-form')
  const { formatMessage } = useIntl()

  const { watch } = useFormContext()

  const vatTotal = watch('VatTotal', 0).toFixed(2)

  return (
    <div className={b('vat-field')}>
      <Text size={'sm'}>{formatMessage({ id: 'CourtCases.Invoicing.Field.VAT' })}</Text>
      <div className={b('vat-text')}>{`${vatTotal} €`}</div>
    </div>
  )
}
